"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectWithMetadataSchema = exports.MetadataSchema = void 0;
const zod_1 = require("zod");
exports.MetadataSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(), zod_1.z.undefined()]));
exports.ObjectWithMetadataSchema = zod_1.z
    .object({
    metadata: exports.MetadataSchema.optional(),
})
    .catchall(zod_1.z.any());
//# sourceMappingURL=metadata.js.map